export const APP_VERSIONS_LIST = "APP_VERSIONS_LIST";
export const APP_VERSIONS_CREATE = "APP_VERSIONS_CREATE";
export const APP_VERSIONS_UPDATE = "APP_VERSIONS_UPDATE";
export const APP_VERSIONS_DELETE = "APP_VERSIONS_DELETE";
export const APP_VERSIONS_SHOW = "APP_VERSIONS_SHOW";
export const APP_VERSIONS_UPDATE_ACTION_LIST = "APP_VERSIONS_UPDATE_ACTION_LIST";
export const APP_VERSIONS_DEVICE_TYPE_LIST = "APP_VERSIONS_DEVICE_TYPE_LIST";
